import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

export const contentTextCss = theme => {
  const { grey20, grey90 } = colorsPalette;

  return css(typography.effra22, {
    color: theme === 'black' ? grey20 : grey90,
    marginBottom: 32,
  });
};

export const headlineCss = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  marginBottom: 16,
  position: 'relative',
});

export const upperHeadlineCss = css(typography.effra18, {
  marginBottom: 8,
});

export const containerPaddingCss = css({
  padding: '64px 0',
  [MediaQueries.mdAndUp]: {
    padding: '96px 0',
  },
});

export const imageCss = css({
  display: 'block',
  height: 'auto',
  margin: '0 auto',
  width: '100%',
});

export const spacerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.mdAndUp]: {
    margin: '96px 0',
  },
});
